import { render, staticRenderFns } from "./courseRelease.vue?vue&type=template&id=33295692&scoped=true&"
import script from "./courseRelease.vue?vue&type=script&lang=js&"
export * from "./courseRelease.vue?vue&type=script&lang=js&"
import style0 from "./courseRelease.vue?vue&type=style&index=0&id=33295692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33295692",
  null
  
)

export default component.exports